// Review Mode endpoints - coach-strategy-canvas-fe-integration.md section 5.
export const strategyCanvasReviewUrls = {
  GET_REVIEW: "/coach/strategy-canvas/{uniqueId}/review",
  SET_BLOCK_STATUS: "/coach/strategy-canvas/{uniqueId}/review/blocks/{blockKey}/status",
  ADD_COMMENT: "/coach/strategy-canvas/{uniqueId}/review/comments",
  DELETE_COMMENT: "/coach/strategy-canvas/{uniqueId}/review/comments/{commentId}",
  // Same path as DELETE_COMMENT above (PUT vs DELETE on the same
  // resource) - named separately for call-site clarity.
  UPDATE_COMMENT: "/coach/strategy-canvas/{uniqueId}/review/comments/{commentId}",
  // Canvas Mode - section 6.
  GET_CANVAS_MODE: "/coach/strategy-canvas/{uniqueId}/canvas-mode",
  // Submit review -> Live Review waiting screen - section 7.1/7.2.
  SUBMIT_REVIEW: "/coach/strategy-canvas/{uniqueId}/review/submit",
  GET_LIVE_REVIEW_STATUS: "/coach/strategy-canvas/{uniqueId}/live-review/status",
  // Section 7.3 - Start Live Review.
  START_LIVE_REVIEW: "/coach/strategy-canvas/{uniqueId}/live-review/start",
  // Section 7.4 - the Live Review session screen itself.
  GET_LIVE_REVIEW: "/coach/strategy-canvas/{uniqueId}/live-review",
  // Section 7.5 - directly overwrite a block's value during Live Review.
  EDIT_LIVE_REVIEW_BLOCK: "/coach/strategy-canvas/{uniqueId}/live-review/blocks/{blockKey}",
  // Section 7.6 - mark a remark as Discussed.
  MARK_REMARK_DISCUSSED: "/coach/strategy-canvas/{uniqueId}/live-review/remarks/discuss",
  // Section 7.7 - lock the canvas (terminal state).
  LOCK_LIVE_REVIEW: "/coach/strategy-canvas/{uniqueId}/live-review/lock",
};

export const REVIEW_STATUS = {
  ACCEPTED: "accepted",
  TO_DISCUSS: "to_discuss",
};

export const COMMENT_SCOPE = {
  BLOCK: "block",
  SECTION: "section",
  OVERALL: "overall",
};
